import { render } from "./CardChallengeResultStatusTextIncomplete.vue?vue&type=template&id=2b19afc0&scoped=true"
import script from "./CardChallengeResultStatusTextIncomplete.vue?vue&type=script&lang=js"
export * from "./CardChallengeResultStatusTextIncomplete.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-status-text-incomplete.css?vue&type=style&index=0&id=2b19afc0&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b19afc0"]])

export default __exports__